import TagCheckIcon from '@mdi/svg/svg/tag-check.svg?react';
import TagIcon from '@mdi/svg/svg/tag-outline.svg?react';
import { Button, MDIIcon } from '@solinkcorp/solink-components';
import { type IEvent } from 'clients/PlatformApi';
import React from 'react';
import useLocale from 'src/hooks/useLocale';

interface EventVerifyButtonProps {
  // The fill color of the verified icon
  verifiedIconFill: string;
  onClick: () => void;
  colorMode: 'light' | 'dark' | undefined;
  event: IEvent;
  size: number;
}

const EventVerifyButton: React.FC<EventVerifyButtonProps> = (props) => {
  const { verifiedIconFill, onClick, colorMode, event, size } = props;
  const locale = useLocale();
  const isEventVerified = !!event.details?.verificationConclusion;
  return (
    <Button
      dataTestId="event-verify"
      onClick={onClick}
      icon={
        <MDIIcon
          icon={isEventVerified ? TagCheckIcon : TagIcon}
          size={size}
          fill={isEventVerified ? verifiedIconFill : undefined}
        />
      }
      iconOnly
      tooltip={isEventVerified ? locale.eventState.seeVerificationResult : locale.eventFlow.review}
      type="clear"
      colorMode={colorMode}
    />
  );
};

export default EventVerifyButton;
